import {Injectable} from '@angular/core';
import * as _ from 'lodash';

@Injectable()
export class RoutingService {
  constructor() {
  }

  addPrevAndNextIdsToRule(rule, group): any {
    const prevRRId = this.calculatePrevRuleId(rule, group, 'After');
    const nextRRId = this.calculateNextRuleId(rule, group, 'After');

    rule.prevRRId = prevRRId;
    rule.nextRRId = nextRRId;

    return rule;
  }

  buildMoveRuleObject(rule): any {
    return Array.isArray(rule) ?
      {rule: rule[0], source: 'rules'} :
      {rule, source: 'groups'};
  }

  populateNames(dataArray): any {
    const mappedNames = dataArray.map((value) => {

      const name: any = {
        name: value.name,
        id: value.id,
        priority: value.priority,
        tbrConditionsIds: value.tbrConditionsIds
      };
      if (value.rrGroupId) {
        name.rrGroupId = value.rrGroupId;
      }
      if (value.routingRules) {
        name.rulesCount = value.routingRules.length;
      }

      return name;
    });

    return mappedNames;
  }

  createRuleToMove(oldRule, parameters): any {
    if (parameters.groupId !== oldRule.rrGroupId) {
      oldRule.rrGroupId = parameters.groupId;
    }

    oldRule.prevRRId = parameters.prevId;
    oldRule.nextRRId = parameters.nextId;

    return oldRule;
  }

  private calculatePrevRuleId(rule, group, position): any {
    const rules = group.routingRules;

    if (rules.length === 0) {
      return -1;
    }

    if (_.isNil(rule.selectedRuleId)) {
      return rules[rules.length - 1].id;
    } else {
      return (position === 'Before') ? this.calculateIdHelperRules(rule, rules, -1) : rule.selectedRuleId;
    }
  }

  private calculateNextRuleId(rule, group, position): any {
    const rules = group.routingRules;

    if (rules.length === 0) {
      return -1;
    }

    if (_.isNil(rule.selectedRuleId)) {
      return -1;
    } else {
      return (position === 'After') ? this.calculateIdHelperRules(rule, rules, 1) : rule.selectedRuleId;
    }
  }

  private calculateIdHelperRules(rule, rules, operator): any {
    const rulesCount = rules.length;

    for (let i = 0; i < rulesCount; i++) {
      if (rules[i].id === rule.selectedRuleId) {
        return (!!(rules[i + operator]) ? rules[i + operator].id : -1);
      }
    }

    return -1;
  }
}
